import * as React from "react";

import { cn } from "@/lib/utils";
import { ErrorLabel } from "@ui/internal/components/label";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  label?: string;
  error?: string | boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      startIcon,
      endIcon,
      label = "",
      error = false,
      ...props
    },
    ref
  ) => {
    return (
      <>
        <div className="flex relative z-0 flex-col gap-1">
          <div className=" bg-white">
            {startIcon && (
              <div className="absolute top-[9px] left-[10px]">{startIcon}</div>
            )}
            <input
              type={type}
              className={cn(
                `flex items-center h-[40px] w-full rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none ${
                  startIcon ? "ps-[40px]" : "px-3"
                } ${endIcon ? "pe-[40px]" : "px-3"}`,
                "file:text-foreground disabled:bg-slate-50 disabled:text-slate-500 placeholder:text-[#A7A5A6] selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input",
                "focus-visible:border-[#1A926C] focus-visible:ring-[#1A926C]/10 focus-visible:ring-[3px] disabled:cursor-not-allowed",
                "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
                className
              )}
              ref={ref}
              {...props}
            />
            {endIcon && (
              <div className="absolute top-[9px] right-[10px]">{endIcon}</div>
            )}
          </div>

          {error && typeof error === "string" && <ErrorLabel message={error} />}
        </div>
      </>
    );
  }
);
Input.displayName = "Input";

export { Input };
